import { AccountDto } from '../routes/account/store/Account';
import { AuthSessionDto } from '../routes/login/store/AuthSession';
import ApiHttpClient from './ApiHttpClient';

export default class Auth {
  constructor(private readonly client: ApiHttpClient) {}

  async signIn(
    email: string,
    password: string,
  ): Promise<AccountDto & AuthSessionDto> {
    try {
      return await this.client.post(`v1/auth/signIn`, {
        email,
        password,
      });
    } catch (e) {
      if (
        e &&
        typeof e === 'object' &&
        'statusCode' in e &&
        e.statusCode === 400
      ) {
        throw new Error('Invalid email or password');
      }

      throw e;
    }
  }

  async refreshIdToken(refreshToken: string): Promise<AuthSessionDto> {
    return this.client.post(
      'v1/auth/refreshIdToken',
      {
        refreshToken,
      },
      { disableSubRequest: true },
    );
  }

  async resetPassword(email: string) {
    return this.client.post('v1/auth/resetPassword', { email });
  }
}
